export default class EntityWorkTypeAssociationMetricNames {
    static CREATE_ATTEMPT = "CreateEntityWorkTypeAssociationAttempt";
    static CREATE_FAILURE = "CreateEntityWorkTypeAssociationFailure";
    static DELETE_ATTEMPT = "DeleteEntityWorkTypeAssociationAttempt";
    static DELETE_FAILURE = "DeleteEntityWorkTypeAssociationFailure";
    static LIST_BY_ENTITY_ID_AND_WORK_TYPE_GROUP_ID_ATTEMPT = "ListEntityWorkTypeAssociationByEntityIdAndWorkTypeGroupIdAttempt";
    static LIST_BY_ENTITY_ID_AND_WORK_TYPE_GROUP_ID_FAILURE = "ListEntityWorkTypeAssociationByEntityIdAndWorkTypeGroupIdFailure";
    static LIST_BY_ENTITY_ID_ATTEMPT = "ListEntityWorkTypeAssociationByEntityIdAttempt";
    static LIST_BY_ENTITY_ID_FAILURE = "ListEntityWorkTypeAssociationByEntityIdFailure";
};